import { render } from "./transfer.vue?vue&type=template&id=b6b8760c&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=ts"
export * from "./transfer.vue?vue&type=script&lang=ts"

import "./transfer.vue?vue&type=style&index=0&id=b6b8760c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6b8760c"

export default script